module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-18.fcbc5814.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/E_SDG_Icons-18.jpg
// module id = 1201
// module chunks = 0